<template>
  <div id="announce-module" class="fixed-size">
    <bds-scroll-area component-class="announcement-scroll">
      <div v-for="(value, key) in announces" :key="key">
        <announcement-item v-model="announces[key]" @change="saveAnnouncement"/>
      </div>
    </bds-scroll-area>
  </div>
</template>

<script>
import ProfileService from "@/services/Profile.service";
import {showErrorNotify, showSuccessNotify} from "@/helpers/functionsHelpers";
import Vue from "vue";
import AnnouncementItem from "@/views/settings/AnnouncementItem";

export default {
  name: "Announcements",
  components: {AnnouncementItem},
  data() {
    return {
      announces: { },
    }
  },
  methods: {
    listAnnouncements() {
      return ProfileService.listAnnouncements().then((announces) => {
        for (let announce of announces) {
          announce.editable = false;
          Vue.set(this.announces, announce.name, announce);
        }
        return Promise.resolve(true);
      }, error => {
        showErrorNotify(this, error);
        return Promise.reject(error);
      });
    },
    saveAnnouncement(data) {
      ProfileService.setAnnouncement(data).then((announce) => {
        Object.assign(this.announces[announce.name], announce);
        announce.editable = false;
        showSuccessNotify(this, this.$t('pages.settings.announcements.msg.editSuccess'));
      }, error => {
        showErrorNotify(this, error);
      })
    },
  },
  mounted() {
    this.listAnnouncements();
  }
}
</script>

<style lang="scss">
#announce-module {
  height: calc(var(--vh, 1vh) * 100 - var(--footer-height-size) - var(--header-height-size));

  .announcement-scroll {
    height: calc(100%);
    padding-bottom: 2rem;

    &:not(.ps) {
       overflow-y: auto;
     }
  }
}
</style>
